<template>
  <div class="centre">
    <h1 class="title is-1">Official Drinking CS:GO rules</h1>
    <ul>
      <li> Death - drink 1</li>
      <li> MVP - Nominate 1 drink</li>
      <li> KOBE! - Nominate 1 drink</li>
      <li> Collat - Nominate 1 drink</li>
      <li> Get a kill at 1 hp - Nominate 1 drink</li>
      <li> Get a knife kill - Everyone else drinks</li>
      <li> Get knifed - 2 drinks</li>
      <li> Team kill - 2 drinks</li>
      <li> Lose the round with all enemies alive - Everyone drinks</li>
      <li> Suicide - 1 drink</li>
      <li> Win a 1vX clutch - Nominate X drinks</li>
      <li> Lose a Xv1 - 1 drink + 1 drink per teammate who died after you</li>
      <li> Ace - Make a rule</li>  
      <li> After getting 2 kills in a round you can call "double down" </li>
      <ul>
        <li> If you get another kill and survive the round, nominate twice as many drinks </li>
        <li> Dying while double'd down means you must drink twice the normal amount for the round</li>
        <li> failing to get another kill, or failure to earn any norminations counts as a death </li>
        <li> You may double down up to twice in a round. </li>
      </ul> 
    </ul>
  </div>
</template>


<script>
export default {
  name: "Csgo",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
};
</script>


<style lang="scss">
h1{
  color:white !important;
}

ul{
  color: rgb(210, 210, 210) !important;
}

.centre{
  height: 100vh;
}
</style>


// WEBPACK FOOTER //
// src/Csgo.vue